import * as Yup from "yup";
import { forceInt } from "Utils";

export const MetaPropertyValidationSchema = Yup.object().shape({});

export const MetaPropertyObjectSchema = {
    id: null,
    field: null,
    type: null,
    value: null,
};

export function transform(requestData) {
    if (requestData.data) {
        return requestData.data.map((item) => transform(item));
    }

    let metaProperty = Object.assign({}, MetaPropertyObjectSchema, {
        id: forceInt(requestData.id),
        field: requestData.field,
        type: requestData.type,
        value: requestData.value,
    });

    return metaProperty;
}
